module.exports = __webpack_public_path__ + "img/fave.4eca75da.png";